// The Policies "Carrier portal account" filter is one dropdown over portal
// logins plus an "added by hand" option. The backend types scrapeAccountIds as uuids
// and would reject the sentinel, so it rides inside the list in the UI and is
// split out into its own flag before every request — exactly as the payment
// format and currency filters do with their own "not specified" options.
//
// One control rather than a list and a checkbox because it answers one
// question: where did this policy come from. "Nowhere" is one of the answers.
export const POLICY_SOURCE_MANUAL = 'MANUAL';

export const splitPolicySourceFilter = (scrapeAccountIds) => {
  const selected = scrapeAccountIds || [];
  return {
    scrapeAccountIds: selected.filter((id) => id !== POLICY_SOURCE_MANUAL),
    scrapeAccountIsEmpty: selected.includes(POLICY_SOURCE_MANUAL),
  };
};
